import { render, staticRenderFns } from "./caset_study_comment.vue?vue&type=template&id=73a9587f"
import script from "./caset_study_comment.vue?vue&type=script&lang=js"
export * from "./caset_study_comment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports